import {useMutation} from "@tanstack/react-query";

import {createLeadMutationOptions} from "./create-lead.mutation-options";

export function useCreateLead() {
  return useMutation(createLeadMutationOptions());
}
